<template>


  <div class="main-contain">
    <div id="id-choose-market" class="main">
      <div id="id-android-market" style="display: flex;flex-direction:column ;align-items: center;">
        <div>
          <a
            id="id-direct-link"
            class="download"
            href="../file/FINDPOP.apk"
          
            download
          >
            <img
              class="market-icon"
              :src="require('/src/assets/img/direct-download.png')"
            />
            <span v-if="lang == 'zh'"> 直接下载 </span>
            <span v-if="lang == 'en'"> Direct Down</span>
          </a>
        </div>
        <div >
          <a
            id="id-goolge-play-link"
            class="download"
            href="https://play.google.com/store/apps/details?id=com.kbd.ledapp3"
          >
            <img
              class="market-icon"
              :src="require('/src/assets/img/google-play.png')"
            />
            <span v-if="lang == 'zh'"> 谷歌商店下载 </span>
            <span v-if="lang == 'en'"> Google Play</span>
          </a>
        </div>
        <div >
          <a
            id="id-apple-store-link"
            class="download"
            href="https://apps.apple.com/us/app/findpop/id1641064444"
          >
            <img
              class="market-icon"
              :src="require('/src/assets/img/applestore.png')"
            />
            <span v-if="lang == 'zh'"> App Store下载 </span>
            <span v-if="lang == 'en'"> App Store</span>
          </a>
        </div>
      </div>
    </div>

    
  </div>
</template>

<script setup>

let lang = "";
if (navigator.language.indexOf("zh") > -1) {
  lang = "zh"; //中文
} else {
  lang = "en"; //不是中文则统一认定为英文
}



</script>

<style scoped>
.download {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

#id-android-market > div{
  width: min-content;
  margin-top:50px ;
}
img {
  width: 100px;
  height: auto;
}
</style>